import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Shield, Calendar } from 'lucide-react';

export default function LegalCenter() {
  const navigate = useNavigate();

  const documents = [
    {
      title: 'Terms of Service',
      description: 'Review our terms and conditions for using Consistency App',
      icon: FileText,
      path: '/legal/terms-of-service',
      color: 'text-blue-400',
      bgColor: 'bg-blue-500/10 border-blue-500/30'
    },
    {
      title: 'Privacy Policy',
      description: 'Learn how we protect and use your data',
      icon: Shield,
      path: '/legal/privacy-policy',
      color: 'text-green-400',
      bgColor: 'bg-green-500/10 border-green-500/30'
    }
  ];

  return (
    <div className="min-h-screen bg-[#121417] py-16 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">Legal Center</h1>
          <p className="text-xl text-gray-400">Important legal information about Consistency App</p>
        </div>

        {/* Document Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {documents.map(doc => {
            const Icon = doc.icon;
            return (
              <button
                key={doc.path}
                onClick={() => navigate(doc.path)}
                className={`p-8 border-2 rounded-lg text-left transition-all hover:scale-105 ${doc.bgColor}`}
              >
                <div className={`w-16 h-16 mb-4 rounded-lg ${doc.bgColor} flex items-center justify-center`}>
                  <Icon className={`w-8 h-8 ${doc.color}`} />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">{doc.title}</h3>
                <p className="text-gray-400">{doc.description}</p>
              </button>
            );
          })}
        </div>

        {/* LLC Notice */}
        <div className="p-6 bg-yellow-500/10 border border-yellow-500/30 rounded-lg">
          <div className="flex items-start gap-3">
            <Calendar className="w-6 h-6 text-yellow-400 flex-shrink-0 mt-1" />
            <div>
              <h4 className="text-lg font-semibold text-yellow-300 mb-2">LLC Transfer Notice</h4>
              <p className="text-yellow-400/90 text-sm">
                This service is operated by New Era Tech Group, LLC (Company-in-Formation). 
                Upon formation of Consistency App LLC, all rights and obligations will transfer automatically.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
